var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { ref } from "vue";
import { BButton } from "bootstrap-vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
export default /*#__PURE__*/ _defineComponent({
    __name: 'AsyncButton',
    props: {
        icon: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: false,
            default: "",
        },
        action: {
            type: Function,
            required: true,
        },
        size: {
            type: String,
            required: false,
            default: "md",
        },
        variant: {
            type: String,
            required: false,
            default: "link",
        },
    },
    setup(__props) {
        const props = __props;
        const loading = ref(false);
        function onClick() {
            return __awaiter(this, void 0, void 0, function* () {
                loading.value = true;
                yield props.action();
                loading.value = false;
            });
        }
        return { __sfc: true, loading, props, onClick, BButton, FontAwesomeIcon };
    }
});
